<div class="file-thumbnail" [class.size-sm]="size === 'sm'" [class.size-md]="size !== 'sm'"
  [ngClass]="'kind-' + kind">

  <!-- Folder tile -->
  @if (kind === 'folder') {
    <div class="folder-tile">
      <mat-icon class="folder-tile-icon">folder</mat-icon>
    </div>
  }

  <!-- Real image preview -->
  @if (showImage) {
    <img class="thumbnail-image" [class.is-loading]="status === 'loading'" [src]="src" [alt]="fileName"
      [attr.loading]="eager ? 'eager' : 'lazy'" decoding="async" (load)="onLoaded()" (error)="onFailed()">
  }

  <!-- Video poster frame -->
  @if (showVideo) {
    <div class="thumbnail-video">
      <video [src]="mediaSource" preload="metadata" muted playsinline
        (loadeddata)="onLoaded()" (error)="onFailed()"></video>
      <span class="video-play-badge">
        <mat-icon>play_circle_filled</mat-icon>
      </span>
    </div>
  }

  <!-- File-type tile: the fallback for every non-previewable file, and for any
       preview that failed to load (missing / expired / restricted / undecodable) -->
  @if (showFallbackTile) {
    <div class="file-tile">
      <mat-icon class="file-tile-icon">{{ icon }}</mat-icon>
      @if (showExtension && extension) {
        <span class="file-tile-extension">{{ extension }}</span>
      }
    </div>
  }

  <!-- Loading shimmer, sits on top until the media reports back -->
  @if (showSkeleton) {
    <div class="thumbnail-skeleton" aria-hidden="true"></div>
  }
</div>
